import { Carousel } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import carousel1 from "../../assets/img/carousel-1.jpg";
import carousel2 from "../../assets/img/carousel-2.jpg";

function HomeBanner() {
  const handleClickSearchBtn = () => {
    const keyword = document.getElementById("keyword");
    keyword.focus();
  };

  return (
    <div className="container-fluid p-0">
      <Carousel indicators={false}>
        <Carousel.Item>
          <img className="d-block w-100" src={carousel1} alt="First slide" />
          <div
            className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center"
            style={style.container}
          >
            <div className="container">
              <div className="row justify-content-start">
                <div className="col-10 col-lg-8">
                  <h1 className="display-3 text-white animated slideInDown mb-4">
                    Find The Perfect Job That You Deserved
                  </h1>
                  <p className="fs-5 fw-medium text-white mb-4 pb-2">
                    Vero elitr justo clita lorem. Ipsum dolor at sed stet sit
                    diam no. Kasd rebum ipsum et diam justo clita et kasd rebum
                    sea elitr.
                  </p>
                  <button
                    className="btn btn-primary py-md-3 px-md-5 me-3 animated slideInLeft"
                    onClick={handleClickSearchBtn}
                  >
                    Search A Job
                  </button>
                  <NavLink
                    to="/post-job"
                    className="btn btn-secondary py-md-3 px-md-5 animated slideInRight"
                  >
                    Find A Talent
                  </NavLink>
                </div>
              </div>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <img className="d-block w-100" src={carousel2} alt="Second slide" />
          <div
            className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center"
            style={style.container}
          >
            <div className="container">
              <div className="row justify-content-start">
                <div className="col-10 col-lg-8">
                  <h1 className="display-3 text-white animated slideInDown mb-4">
                    Find The Best Startup Job That Fit You
                  </h1>
                  <p className="fs-5 fw-medium text-white mb-4 pb-2">
                    Vero elitr justo clita lorem. Ipsum dolor at sed stet sit
                    diam no. Kasd rebum ipsum et diam justo clita et kasd rebum
                    sea elitr.
                  </p>
                  <button
                    className="btn btn-primary py-md-3 px-md-5 me-3 animated slideInLeft"
                    onClick={handleClickSearchBtn}
                  >
                    Search A Job
                  </button>
                  <NavLink
                    to="/post-job"
                    className="btn btn-secondary py-md-3 px-md-5 animated slideInRight"
                  >
                    Find A Talent
                  </NavLink>
                </div>
              </div>
            </div>
          </div>
        </Carousel.Item>
      </Carousel>
    </div>
  );
}

const style = {
  container: { background: "rgba(43, 57, 64, .5)" },
};

export default HomeBanner;
